export const generateSimulationsOptions = (): uui.domain.ui.list.ListOptions => {
  return {
    search: {
      query: '',
      fields: ['name'],
      operator: 'or',
      exactMatch: false,
    },
    filter: [],
    sort: [
      {
        field: 'lastEdit',
        direction: 'asc',
      },
    ],
    group: [],
  }
}
